<!-- eslint-disable vue/no-v-html -->
<template>
  <div @mousemove="mouseMove">
    <!-- <div v-if="loading" class="w-full">
      <FullScreeenLoader />
    </div> -->
    <div class="overflow-hidden">
      <div class="navbar-wrapper">
        <Navbar
          :is-dark="true"
          @mouseover="
            setCursor(null, null, {
              'font-size': '14px',
              cursor: 'unset',
              'z-index': '1',
              width: '25px',
              height: '25px',
              opacity: 0.7,
            })
          "
        />
      </div>

      <div class="lg:relative">
        <Bubbles
          v-if="width > 1024"
          :key="width"
          class="w-full !absolute top-0"
          :height="getHeight"
          :start-width="700"
          :set-cursor="setCursor"
          ref-prop="canvasMembership"
        />
        <div class="w-full pt-28 lg:pt-32 pointer-events-none">
          <div class="flex justify-start lg:justify-center pointer-events-none">
            <div class="max-w-7xl pointer-events-none relative overflow-hidden">
              <div class="pb-12 lg:pb-24 px-6 pointer-events-none">
                <ClientOnly>
                  <AnimateTitle :title="$t('projects.title')" />
                </ClientOnly>
              </div>
              <div class="w-full flex justify-center">
                <NuxtImg
                  sizes="1280px"
                  class="w-full max-w-7xl"
                  src="https://be.opero.cz/wp-content/uploads/2024/04/projects_hero.jpg"
                  format="webp"
                  :placeholder="[1280, 853, 75, 75]"
                />
              </div>
              <div class="project">
                <BubbleText
                  key="key"
                  class="relative spaces-bubbletext pointer-events-none w-full"
                  :set-cursor="setCursor"
                >
                  <div
                    class="bubbleText relative z-10 py-4 pt-12 lg:py-24 w-full max-w-7xl"
                  >
                    <div class="bubble-text pointer-events-none">
                      <div class="pointer-events-none px-2">
                        <AnimatePerex :title="$t('projects.perex')" />
                      </div>
                    </div>
                  </div>
                </BubbleText>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="meetings"
        class="flex justify-center"
        @mouseenter="
          setCursor(null, null, {
            'font-size': '14px',
            background: '#FFC800',
            width: '25px',
            height: '25px',
            'z-index': '-1',
          })
        "
      >
        <div class="max-w-7xl">
          <div
            class="flex flex-col md:flex-row pt-12 p-6 sm:p-8 lg:px-6 lg:p-14 gap-5 md:gap-28"
          >
            <h2 class="h1 lg:whitespace-nowrap">
              {{ $t("projects.entrepreneurship.title") }}
            </h2>
            <div class="flex-2">
              <p>{{ $t("projects.entrepreneurship.subtitle") }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="flex justify-center px-6 pt-12">
        <div v-if="width > 768" class="max-w-7xl">
          <div
            class="md:flex gap-16 p-6 md:p-0"
            @click="scrollTo('https://dotoho.pro')"
            @mouseenter="
              setCursor('VÍCE', null, {
                'font-size': '14px',
                background: '#FFC800',
                width: '100px',
                height: '100px',
              })
            "
          >
            <NuxtImg
              src="/img/dotoho.png"
              sizes="430px"
              class="projects-example"
              format="webp"
              loading="lazy"
            />
            <p class="md:w-96 p-5 flex items-center">
              {{ $t("projects.featuredProjects.dotoho") }}
            </p>
          </div>
          <div
            class="md:flex gap-16 mt-8 md:mt-16 p-6 md:p-0"
            @click="scrollTo('https://ment2grow.com')"
            @mouseenter="
              setCursor('VÍCE', null, {
                'font-size': '14px',
                background: '#FFC800',
                width: '100px',
                height: '100px',
              })
            "
          >
            <NuxtImg
              src="/img/m2g.png"
              sizes="430px"
              class="projects-example"
              format="webp"
              loading="lazy"
            />
            <p class="md:w-96 p-5 flex items-center">
              {{ $t("projects.featuredProjects.m2g") }}
            </p>
          </div>
          <!-- <div class="md:flex gap-16 mt-8 md:mt-16 p-6 md:p-0">
            <NuxtImg
              src="/img/yodas.png"
              sizes="430px"
              class="projects-example"
              format="webp"
              loading="lazy"
            />
            <p class="md:w-96 p-5 flex items-center">
              {{ $t("projects.featuredProjects.openUp") }}
            </p>
          </div> -->
        </div>
        <div v-else class="w-full px-0">
          <Carousel
            ref="carouselProjects2"
            v-bind="settings2"
            v-model="currentSlide1"
            :breakpoints="breakpoints"
            class="w-full carousel-projects"
            :style="{ 'max-width': width - 15 }"
          >
            <Slide key="projects-featured1">
              <div
                class="md:flex gap-16 p-6 md:p-0 projects-example-mobile"
                @click="scrollTo('https://dotoho.pro')"
                @mouseenter="
                  setCursor('VÍCE', null, {
                    'font-size': '14px',
                    background: '#FFC800',
                    width: '100px',
                    height: '100px',
                  })
                "
              >
                <NuxtImg
                  src="/img/dotoho.png"
                  sizes="430px"
                  class="projects-example23"
                  format="webp"
                  loading="lazy"
                />
                <p class="p-5 flex items-center">
                  {{ $t("projects.featuredProjects.dotoho") }}
                </p>
              </div>
            </Slide>
            <Slide key="projects-featured2">
              <div
                class="md:flex gap-16 md:mt-16 p-6 md:p-0 projects-example-mobile"
                @click="scrollTo('https://ment2grow.com')"
                @mouseenter="
                  setCursor('VÍCE', null, {
                    'font-size': '14px',
                    background: '#FFC800',
                    width: '100px',
                    height: '100px',
                  })
                "
              >
                <NuxtImg
                  src="/img/m2g.png"
                  sizes="430px"
                  class="projects-example23"
                  format="webp"
                  loading="lazy"
                />
                <p class="p-6 flex items-center w-full">
                  {{ $t("projects.featuredProjects.m2g") }}
                </p>
              </div>
            </Slide>
            <Slide key="projects-featured3">
              <div
                class="md:flex gap-16 md:mt-16 p-6 md:p-0 projects-example-mobile"
                @click="scrollTo('https://www.yodas.opero.cz')"
                @mouseenter="
                  setCursor('VÍCE', null, {
                    'font-size': '14px',
                    background: '#FFC800',
                    width: '100px',
                    height: '100px',
                  })
                "
              >
                <NuxtImg
                  src="/img/yodas.png"
                  sizes="430px"
                  class="projects-example23"
                  format="webp"
                  loading="lazy"
                />
                <p class="p-5 flex items-center w-full">
                  {{ $t("projects.featuredProjects.yodas") }}
                </p>
              </div>
            </Slide>
          </Carousel>
          <div class="px-6">
            <div
              class="w-full bg-gray-200 rounded-full h-1 dark:bg-gray-700 mt-4"
            >
              <div
                class="bg-blue-600 h-1 rounded-full"
                :style="{
                  width: `${(currentSlide1 + 1) * 33.33333}%`,
                  transition: 'width 0.3s',
                  background: '#FFC800',
                }"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="meetings"
        class="flex justify-center"
        @mouseenter="
          setCursor(null, null, {
            'font-size': '14px',
            background: '#FFC800',
            width: '25px',
            height: '25px',
            'z-index': '-1',
          })
        "
      >
        <div class="max-w-7xl">
          <div
            class="flex flex-col md:flex-row p-6 sm:p-8 lg:px-6 lg:p-14 pt-20 lg:pt-36 gap-5 md:gap-28"
          >
            <h2 class="h1 lg:whitespace-nowrap">
              {{ $t("projects.moreProjects.title") }}
            </h2>
            <div class="flex-2">
              <p>{{ $t("projects.events.subtitle") }}</p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="flex justify-center"
        @mouseenter="
          setCursor(null, null, {
            'font-size': '14px',
            background: '#FFC800',
            width: '25px',
            height: '25px',
            'z-index': '-1',
          })
        "
      >
        <div class="max-w-7xl lg:flex gap-32 px-6 mb-12 lg:mb-0 w-full">
          <ClientOnly>
            <div
              v-show="data && width > 768"
              class="grid grid-cols-3 gap-4 all-projects"
            >
              <!-- <p v-for="item in data.projects.edges">{{ item.node.title }}</p> -->
              <ProjectCard
                v-for="(project, i) in data?.projects?.edges.slice(
                  0,
                  numOfProjectsToShow
                )"
                :key="i"
                class="panel-projects"
                :src="project?.node"
              />
            </div>
          </ClientOnly>
          <div v-if="data && width < 768">
            <Carousel
              ref="carouselProjects"
              v-model="currentSlide2"
              :breakpoints="breakpoints2"
              v-bind="settings"
              class=""
            >
              <Slide v-for="(project, i) in data?.projects?.edges" :key="i">
                <ProjectCard :src="project?.node" />
              </Slide>
            </Carousel>
            <div
              class="w-full bg-gray-200 rounded-full h-1 dark:bg-gray-700 mt-4"
            >
              <div
                class="bg-blue-600 h-1 rounded-full"
                :style="{
                  width: `${
                    ((Math.ceil(currentSlide2) + 1) * 100) /
                    data?.projects?.edges?.length
                  }%`,
                  transition: 'width 0.3s',
                  background: '#FFC800',
                }"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="flex justify-center pb-10 lg:pb-24"
        @mouseenter="
          setCursor(null, null, {
            'font-size': '14px',
            background: '#FFC800',
            width: '25px',
            height: '25px',
            'z-index': '-1',
          })
        "
      >
        <button
          v-if="width > 768"
          class="pointer-events-auto whitespace-nowrap bg-transparent border rounded-full border-black px-4 py-2 text-sm"
          @click="numOfProjectsToShow = numOfProjectsToShow === 6 ? 100 : 6"
        >
          {{
            numOfProjectsToShow === 6
              ? $t("projects.moreProjects.button.v1")
              : $t("projects.moreProjects.button.v2")
          }}
        </button>
      </div>

      <PartnersWrapper :is-projects="true" :set-cursor="setCursor" />

      <BecomeMember :set-cursor="setCursor" />
      <Footer :set-cursor="setCursor" />
      <div
        id="cursor"
        class="hidden cursor-auto lg:cursor-none lg:flex pointer-events-none"
        :style="cursorStyle"
        :class="{
          smallCursor: cursor === null,
        }"
        @click="cursorOnClick"
        v-html="cursor"
      ></div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import { Carousel, Slide } from "vue3-carousel";
import BubbleText from "~/components/Hero/BubbleText.vue";
import ProjectCard from "~/components/Hero/ProjectCard.vue";

export default {
  name: "Space",
  components: { Carousel, Slide, ProjectCard, BubbleText },
  setup() {
    const { t } = useI18n();
    const route = useRoute();
    useHeadMeta({
      title: t("projects.meta.title"),
      description: t("projects.meta.description"),
      url: route.fullPath,
      csUrl: 'cs/projekty',
      enUrl: 'en/projects',
      image:
        "https://www.opero.cz/img/1_Opero_prostor_k_pronajmu_konference_praha_1_design.jpg",
    });
  },
  data() {
    return {
      currentImage: 0,
      currentImage2: 0,
      cursor: "",
      cursorStyle: {},
      width: 1365,
      xTo: null,
      yTo: null,
      variables: { limit: 5 },
      loading: false,
      data: null,
      breakpoints: {
        500: {
          itemsToShow: 1.7,
          snapAlign: "center",
        },
        600: {
          itemsToShow: 2.3,
          snapAlign: "start",
        },
      },
      breakpoints2: {
        500: {
          itemsToShow: 2.3,
          snapAlign: "center",
        },
        600: {
          itemsToShow: 2.3,
          snapAlign: "start",
        },
      },

      settings: {
        itemsToShow: 1.3,
        snapAlign: "start",
      },
      settings2: {
        itemsToShow: 1.2,
        snapAlign: "center",
      },
      currentSlide1: 0,
      currentSlide2: 0,

      tmpDataSrc: [
        {
          src: "/img/maskgroup3.png",
          title: "DoToho ",
          logo: "/img/logo-dotoho.svg",
          desc: "Opero nabízí mentoringový program pro malé a střední podnikatele, kterým prošlo již více než 500 českých firem. Chcete také posunout svůj byznys o krok dál? ",
        },
        {
          src: "/img/spolecnost.4.0.jpg",
          title: "Společnost 4.0  ",
          logo: "/img/logo-spolecnost-4.svg",
          desc: "V rámci cyklu debat Společnost 4.0 se zaměřujeme na Série interdisciplinární témata, která mají klíčový dopad na společnost. Akce připravujeme společně s<br> NF Neuron, Aspen Institute CE a dalšími.",
        },
        {
          src: "/img/2023_Ment2Grow_PitchNight-62-min.jpg",
          title: "Ment2Grow  ",
          logo: "/img/logo_ment2grow.svg",
          desc: "Akcelerační program pro technologické B2B startupy s globální ambicí, v jednotné fázi vývoje, se zaměřením na pomoc s byznys developmentem a expanzí do zahraničí. ",
        },
        {
          src: "/img/future.jpg",
          title: "FutureEdu ",
          logo: "/img/logo_future_edu.png",
          desc: "Každý rok pořádá Opero konferenci FutureEdu, která přispívá k definici vize českého vzdělávacího systému. Sdílení dobré praxe, diskuse mezi klíčovými stakeholdery a mapování světových trendů ve vzdělávání.  ",
        },
        {
          src: "/img/Yodas_opero_program.jpg",
          title: "Yodas  ",
          logo: "/img/logo_Yodas.png",
          desc: " Program pro zakladatele a majitele firem <br>z různých odvětví, jehož cílem je najít odpovědi na klíčové otázky v oblasti byznysu. Účastníci jsou vždy pečlivě vybíráni, abychom zajistili co největší přínos. ",
        },
        {
          src: "/img/maskgroup3.png",
          title: "DoToho ",
          logo: "/img/logo-dotoho.svg",
          desc: "Opero nabízí mentoringový program pro malé a střední podnikatele, kterým prošlo již více než 500 českých firem. Chcete také posunout svůj byznys o krok dál? ",
        },
        {
          src: "/img/spolecnost.4.0.jpg",
          title: "Společnost 4.0  ",
          logo: "/img/logo-spolecnost-4.svg",
          desc: "V rámci cyklu debat Společnost 4.0 se zaměřujeme na Série interdisciplinární témata, která mají klíčový dopad na společnost. Akce připravujeme společně s<br> NF Neuron, Aspen Institute CE a dalšími.",
        },
        {
          src: "/img/2023_Ment2Grow_PitchNight-62-min.jpg",
          title: "Ment2Grow  ",
          logo: "/img/logo_ment2grow.svg",
          desc: "Akcelerační program pro technologické B2B startupy s globální ambicí, v jednotné fázi vývoje, se zaměřením na pomoc s byznys developmentem a expanzí do zahraničí. ",
        },
        {
          src: "/img/future.jpg",
          title: "FutureEdu ",
          logo: "/img/logo_future_edu.png",
          desc: "Každý rok pořádá Opero konferenci FutureEdu, která přispívá k definici vize českého vzdělávacího systému. Sdílení dobré praxe, diskuse mezi klíčovými stakeholdery a mapování světových trendů ve vzdělávání.  ",
        },
      ],
      numOfProjectsToShow: 6,
    };
  },
  computed: {
    getHeight() {
      if (this.width > 1350) return 1550;
      return this.width + 200;
    },
  },
  // computed: {
  //     bubblesWidth() {
  //         if (this.width > 1024) {
  //
  //         }
  //         if (this.width > 1024) {
  //
  //         }
  //         if (this.width > 1024) {
  //
  //         }
  //
  //         return
  //     }
  // },

  async created() {
    // const { locale } = useI18n();

    const locale = this.$i18n.locale;

    const query = gql`
  query CustomPages {
    projects (first: 100, where: {language: ${locale.toUpperCase()}}) {
			edges {
				node {
					id
					title

					projectsConfig {
						externalLink
						internalPost {
							... on Post {
								id
								slug
							}
						}
						content
						images {
							image {
								mediaItemUrl
							}
							logo {
								mediaItemUrl
							}
						}
					}
				}
			}
		}
}

`;
    const { data } = await useAsyncQuery(query, this.variables);

    this.data = data;
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);

    window.addEventListener("resize", this.handleResize);

    this.width =
      document.body.clientWidth ||
      window.innerWidth ||
      document.documentElement.clientWidth;
    if (this.width > 1024) {
      gsap.set("#cursor", { xPercent: -50, yPercent: -50 });

      this.xTo = gsap.quickTo("#cursor", "x", {
        duration: 0.1,
        ease: "power3",
      });
      this.yTo = gsap.quickTo("#cursor", "y", {
        duration: 0.1,
        ease: "power3",
      });
    }
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
    window.document.removeEventListener("click", this.cursorOnClick);
  },
  methods: {
    changeTestimonial(t) {
      this.currentImage = t;
    },
    changeTestimonial2(t) {
      this.currentImage2 = t;
    },
    scrollTo(url) {
      window.open(url, "_blank");
    },

    setCursor(value, onClick, style) {
      this.cursor = value;
      if (this.cursorOnClick !== onClick) {
        window.document.removeEventListener("click", this.cursorOnClick);
        this.cursorOnClick = onClick;

        window.document.addEventListener("click", this.cursorOnClick);
      }
      if (this.cursorStyle !== style) {
        this.cursorStyle = style;
      }
    },
    cursorOnClick: () => {},
    mouseMove(e) {
      if (this.width > 1024) {
        // this.xTo = e.pageX;
        // this.yTo = e.pageY;
        //
        this.xTo(e.pageX);
        this.yTo(e.pageY);
      }
    },
    handleScroll() {},
    handleResize() {
      this.width =
        document?.body?.clientWidth ||
        window?.innerWidth ||
        document?.documentElement?.clientWidth;
      if (this.width > 1024) {
        gsap.set("#cursor", { xPercent: -50, yPercent: -50 });

        this.xTo = gsap.quickTo("#cursor", "x", {
          duration: 0.1,
          ease: "power3",
        });
        this.yTo = gsap.quickTo("#cursor", "y", {
          duration: 0.1,
          ease: "power3",
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.project .bubbleText {
  @media (max-width: 1024px) {
    display: relative !important;
  }
}

.spaces-bubbletext {
  // position: relative;
  // top: -550px;

  // margin-left: -32px;
  @media screen and (max-width: 1024px) {
    // margin-left: 0px;
    // top: 0;
  }
}

#cursor {
  position: absolute;
  top: 0;
  left: -10px;
  width: 25px;
  height: 25px;
  display: none;
  font-weight: 400;

  justify-content: center;
  align-items: center;
  background-color: $color-primary;
  border-radius: 50%;
  z-index: 1000;
  cursor: none;
  transition:
    width 0.3s,
    height 0.3s,
    background-color 0.3s;
  transform: translate(-50%, -50%) translate(-150px, -150px);
  //pointer-events: none;
  text-align: center;
  @media screen {
    @media (pointer: fine) {
      display: flex;
    }
  }
}

.smallCursor {
  width: 20px;
  height: 20px;
  background-color: $color-primary;
}

.all-projects {
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: 1280px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 1000px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 660px) {
    grid-template-columns: repeat(1, 1fr);
  }

  .project-card-container {
    //width: 100%;
    min-width: unset;
  }
}

.projects-example {
  width: 430px;
  @media (max-width: 768px) {
    width: 100% !important;
  }
  @media (max-width: 768px) {
    width: 250px !important;
    height: 187px;
    object-fit: cover;
  }
}

.carousel__slide {
  align-items: unset;
}

.projects-example-mobile {
  width: 100%;
  text-align: left;
  padding: 0 !important;
}

.projects-example23 {
  width: 100%;
}

.carousel__viewport {
  overflow: hidden;
}

.carousel-projects {
  max-width: 370px;
  @media screen and (max-width: 800px) {
    max-width: 600px;
  }
  @media screen and (max-width: 600px) {
    max-width: 500px;
  }
  @media screen and (max-width: 500px) {
    max-width: 400px;
  }
  @media screen and (max-width: 400px) {
    max-width: 370px;
  }

  .carousel__slide {
    padding-right: 20px;
  }
}
</style>

<style lang="scss">
.all-projects {
  .logo-projects {
    width: 100% !important;
    //height: auto;
  }
}

.hero-img-main {
  //width: 1280px;
  @media (max-width: 1280px) {
    width: 100%;
  }
}
</style>
